<template>
    <div v-loading="loading">
        <div class="input-part">
            <span tkey="標題">{{i18n.tkey("lang_title")}}</span>
            <br>
            <el-input v-model="addinfo4"></el-input>
        </div>

        <div class="input-part">
            <span tkey="請選擇類別">{{i18n.tkey("lang_please_select_type")}}</span>
            <br>
            <el-select v-model="addinfo1">
                <el-option
                    :label="i18n.tkey('lang_hyperlink')"
                    :value="'0'"
                />

                <el-option
                    :label="i18n.tkey('lang_QRCode')"
                    :value="'1'"
                />
            </el-select>
        </div>

        <div class="input-part">
            <span style="margin-right: 10px" tkey="選擇圖片">{{i18n.tkey("lang_choose_img")}}</span>
            <el-select v-model="selectImg" @change="changeImgSelect">
                <el-option
                        :label="i18n.tkey('lang_custom_text')"
                        :value="''"
                />

                <el-option
                        :label="'FaceBook'"
                        :value="'/static/images/icon_facebook.png'"
                />

                <el-option
                        :label="'WeChat'"
                        :value="'/static/images/icon_wechat.png'"
                />

                <el-option
                        :label="'Instagram'"
                        :value="'/static/images/icon_instagram.png'"
                />

                <el-option
                        :label="'Twitter'"
                        :value="'/static/images/icon_twitter.png'"
                />

            </el-select>
            <br>
            <br>
            <uploadImg v-model="addinfo2Preview" @selectComplete="uploadAddinfo2Img" />
        </div>

        <div v-show="addinfo1 == '0'" class="input-part">
            <span tkey="個人鏈接">{{i18n.tkey("lang_personal_link")}}</span>
            <br>
            <el-input v-model="addremark1"></el-input>
        </div>

        <div v-show="addinfo1 == '1'" class="input-part">
            <span tkey="二維碼">{{i18n.tkey("lang_QRCode")}}</span>
            <br>
            <uploadImg v-model="addinfo3Preview" @selectComplete="uploadAddinfo3Img" />
        </div>

        <div style="text-align: center">
            <el-button type="primary" v-if="null == editObj" @click="addRecord7" tkey="提交">{{i18n.tkey("lang_submit")}}</el-button>
            <el-button type="primary" v-if="null != editObj" @click="updateRecord7" tkey="保存">{{i18n.tkey("lang_save")}}</el-button>
        </div>

    </div>
</template>

<script setup>
    import {ref, onMounted, getCurrentInstance, toRef, inject} from "vue";
    import uploadImg from "@/components/shopopee/form/uploadImg"
    import record7Api from "@/request/record7Api";
    import {useUserinfo} from "@/stores/userinfo";
    import myUtil from "@/util/util";
    import cardApi from "@/request/api";
    import memberWorkApi from "@/request/memberWorkApi";

    const { updateAddinfo1 } = inject('myCardViewFunc', { updateAddinfo1: () => {  } })
    const {updateInputBy } = inject('myCompanyViewFunc', { updateInputBy: () => {  } })

    //響應機制的userinfo
    const userInfoRef = toRef(useUserinfo())

    const i18n = inject("i18n")

    const props = defineProps(["editObj", "editCard","isCompany"])
    const emits = defineEmits(["operateComplete"])
    const { proxy } = getCurrentInstance()

    const loading = ref(false)

    const addinfo4 = ref("")
    const addinfo1 = ref("0")
    const addinfo2Preview = ref(null)
    const addinfo2 = ref(null)
    const addinfo3Preview = ref(null)
    const addinfo3 = ref(null)
    const addremark1 = ref("")

    const selectImg = ref("")
    const isCompany = ref(false)

    function fillObj(){
        addinfo4.value = props.editObj.addinfo4
        addinfo1.value = props.editObj.addinfo1
        if (myUtil.isNotEmpty(props.editObj.addinfo2)){
            addinfo2Preview.value = proxy.$ShopopeeUrl + props.editObj.addinfo2
            addinfo2.value = props.editObj.addinfo2
        }

        if (myUtil.isNotEmpty(props.editObj.addinfo3)){
            addinfo3Preview.value = proxy.$ShopopeeUrl + props.editObj.addinfo3
            addinfo3.value = props.editObj.addinfo3
        }

        addremark1.value = props.editObj.addremark1
    }

    function changeImgSelect(){
        if (null == selectImg.value){
            addinfo2.value = null
            addinfo2Preview.value = null
        }else{
            addinfo2.value = selectImg.value
            addinfo2Preview.value = `${proxy.$ShopopeeUrl}${selectImg.value}`
        }
    }

    function uploadAddinfo2Img(src){
        uploadImgFunc(src, (src) => {
            addinfo2.value = src
            // addinfo2Preview.value = `${proxy.$ShopopeeUrl}${src}`
        })
    }

    function uploadAddinfo3Img(src){
        uploadImgFunc(src, (src) => {
            addinfo3.value = src
            // addinfo3Preview.value = `${proxy.$ShopopeeUrl}${src}`
        })
    }

    function uploadImgFunc(src, callback){
        const request = record7Api.updaIconFile
        const params = request.getParams()

        params.companycode = userInfoRef.value.companycode
        params.imgs = src

        request.send(params, (res) => {
            if (res.code == 200){
                callback(res.detail)
            }
        })
    }

    function addRecord7(){
        loading.value = true
        const request = record7Api.addAdditionalrecord7
        const params = request.getParams()

        params.companycode = userInfoRef.value.companycode
        params.addremark1 = addremark1.value
        params.addinfo1 = addinfo1.value
        params.addinfo2 = addinfo2.value
        params.addinfo3 = addinfo3.value
        params.addinfo4 = addinfo4.value

        request.send(params, (res) => {
            if (res.code == 200){
                updateCard(res.detail.id)
            }else{
                myUtil.alertError(res.msg)
            }
        })
    }

    function updateRecord7(){
        loading.value = true
        const request = record7Api.updateAdditionalrecord7
        const params = request.getParams()

        params.id = props.editObj.id
        params.companycode = props.editObj.companycode
        params.addremark1 = addremark1.value
        params.addinfo1 = addinfo1.value
        params.addinfo2 = addinfo2.value
        params.addinfo3 = addinfo3.value
        params.addinfo4 = addinfo4.value

        request.send(params, (res) => {
            loading.value = false
            if (res.code == 200){
                myUtil.alertSuccess(i18n.tkey("lang_save_success"))
            }else{
                myUtil.alertError(res.msg)
            }
        })
    }

    function updateCard(id){

        if(isCompany.value === true){
          const request = memberWorkApi.updateMemberWorkByInputBy
          const params = request.getParams()

            params.companycode = props.editCard.companycode

            params.inputby = props.editCard.inputby + `,${id}`
            if (myUtil.isNotEmpty(params.inputby) && params.inputby.charAt(0) === ","){
              params.inputby = params.inputby.substring(1)
            }

            request.send(params, (res) => {
              loading.value = false
              if (res.code == 200){
                debugger
                updateInputBy(params.inputby)
                myUtil.alertSuccess(i18n.tkey("lang_submit_success"))
                emits("operateComplete")
              }
            })
        }else{
        const request = cardApi.update
        const params = request.getParams()

        params.id = props.editCard.id
        params.addinfo1 = props.editCard.addinfo1 + `,${id}`

        if (myUtil.isNotEmpty(params.addinfo1) && params.addinfo1.charAt(0) === ","){
            params.addinfo1 = params.addinfo1.substring(1)
        }

        request.send(params, (res) => {
            loading.value = false
            if (res.code == 200){
                updateAddinfo1(params.addinfo1)
                myUtil.alertSuccess(i18n.tkey("lang_submit_success"))
                emits("operateComplete")
            }
        })
        }
    }

    onMounted(() => {
        if(null != props.isCompany){
          isCompany.value = props.isCompany
        }
        if (null != props.editObj){
            fillObj()
        }
    })

</script>

<style scoped>
    .input-part {
        margin-bottom: 15px;
    }
</style>